"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceVariantDetails = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Button_1 = require("../../../Button");
const Icon_1 = require("../../../Icon");
const rateTypeMapper_1 = require("../rateTypeMapper");
require("./index.scss");
const className = 'price-variant-details';
const PriceVariantDetails = (props) => {
    const { isSelectFlightButtonDisabled, modificators, onSelectFlightButtonClick, rateType, info, } = props;
    const { detailsConfig, detailedDescription, title, } = rateTypeMapper_1.rateTypeConfigMap[rateType] || {};
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        rateTypeMapper_1.rateTypeToModifierMap[rateType],
        modificators,
    ]);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("h3", { className: `${className}__title` }, title),
            react_1.default.createElement("div", { className: `${className}__body` },
                detailsConfig && (react_1.default.createElement("div", { className: `${className}__options` },
                    react_1.default.createElement("ul", null, detailsConfig.map((detailsItem, idx) => (react_1.default.createElement("li", { key: `detailsConfig::${detailsItem.icon}:${idx}` },
                        react_1.default.createElement(Icon_1.Icon, { name: detailsItem.icon }),
                        detailsItem.text)))))),
                detailedDescription && (react_1.default.createElement("div", { className: `${className}__content` }, detailedDescription))),
            !isSelectFlightButtonDisabled && (react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/Details/Button:SelectFlight', defaultMessage: 'Select this flight' }), modificators: ['important'], onClick: () => {
                        onSelectFlightButtonClick === null || onSelectFlightButtonClick === void 0 ? void 0 : onSelectFlightButtonClick(info);
                    } }))))));
};
exports.PriceVariantDetails = PriceVariantDetails;
//# sourceMappingURL=index.js.map